import { VisitMemberPresenceCounters } from "../lib/visit-member";
import { VisitMemberGeneratedEntity } from "./generated/VisitMemberGeneratedEntity";

interface PresenceCounter {
    lateCount: number;
    presenceCount: number;
    excusedCount: number;
    absenceCount: number;
}

export enum VisitMemberPresenceTypes {
    Absent = 0,
    Present = 1,
    Excused = 2,
    Late = 3,
    Unknown = -1,
}

export const ValidVisitMemberPresenceTypes: ReadonlyArray<VisitMemberPresenceTypes> = [
    VisitMemberPresenceTypes.Absent,
    VisitMemberPresenceTypes.Present,
    VisitMemberPresenceTypes.Excused,
    VisitMemberPresenceTypes.Late,
];

export abstract class VisitMemberEntity extends VisitMemberGeneratedEntity {
    public get presenceCounters(): PresenceCounter {
        const countersHelper = new VisitMemberPresenceCounters(this.getContext());
        return countersHelper.getCountersForVisitMember(this);
    }
}
